import { Component, Inject, OnInit } from '@angular/core';
import {
  MatBottomSheetRef,
  MAT_BOTTOM_SHEET_DATA,
} from '@angular/material/bottom-sheet';
import { TextHelper } from 'src/app/utils/text-helper';

@Component({
  selector: 'app-recipe-detail-bottomsheet',
  templateUrl: './recipe-detail-bottomsheet.component.html',
  styleUrls: ['./recipe-detail-bottomsheet.component.scss'],
})
export class RecipeDetailBottomsheetComponent implements OnInit {
  SWIPE_ACTION = { UP: 'swipeup', DOWN: 'swipedown' };

  selectedRatio: string;
  ratios: string[];
  amount: string;

  unitTitle = '';
  isButtonActive = true;
  cookingBook = false;
  selectUnit = false;
  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private bottomSheetRef: MatBottomSheetRef<RecipeDetailBottomsheetComponent>,
    private textHelper: TextHelper
  ) {}

  ngOnInit() {
    if (this.data.cookingBook) {
      this.cookingBook = true;
    }
    this.amount = this.data.amount;
    this.setFoodRatios();
  }

  swipe(action: string = this.SWIPE_ACTION.DOWN) {
    if (action === this.SWIPE_ACTION.DOWN) {
      this.bottomSheetRef.dismiss();
    }
  }

  setFoodRatios() {
    this.ratios = [];
    this.selectedRatio = this.data.selectedRatio;
    this.data.food.foodUnitRatioArray.forEach((r) => {
      this.ratios.push(r.unitId.name);
    });
    this.ratios.push('گرم');
  }

  calculateGram() {
    if (this.amount && this.amount !== '') {
      this.amount = this.textHelper.replacePersian(this.amount);
    }
    if (this.amount && this.amount !== '0') {
      const isGram = this.selectedRatio === 'گرم';
      if (isGram) {
        this.unitTitle = '';
      } else {
        this.data.food.foodUnitRatioArray.forEach((r) => {
          if (r.unitId.name === this.selectedRatio) {
            const gram = this.addZeroes(
              (parseFloat(this.amount) * r.ratio).toString()
            );
            this.unitTitle = gram + ' گرم';
          }
        });
      }
      this.isButtonActive = true;
    } else {
      const isGram = this.selectedRatio === 'گرم';
      if (isGram) {
        this.unitTitle = '';
      } else {
        this.unitTitle = '۰ گرم';
      }
      this.isButtonActive = false;
    }
  }

  submit() {
    if (this.isButtonActive) {
      this.animateButton();
      this.bottomSheetRef.dismiss({
        selectedRatio: this.selectedRatio,
        amount: this.amount,
      });
    }
  }

  animateButton() {
    const button = document.getElementById('add-button');
    button.style.width = '56px';
    button.style.right = 'calc( 50% - 28px )';
  }

  addZeroes(num: string) {
    const dec = num.split('.')[1];
    const len = dec ? (dec.length < 2 ? dec.length : 2) : 0;
    return Number(num).toFixed(len);
  }
  openChangeUnit() {
    this.selectUnit = true;
  }
  backtoUnit() {
    this.selectUnit = false;
  }
  changeCookingUnit(ratio) {
    this.selectedRatio = ratio;
    this.backtoUnit();
  }
}
